import { LGT_SERVER_URL, WORKOS_LEGITIMATE_ORG_ID } from "@/lib/env";

export const LOGIN_URL = `${LGT_SERVER_URL}/auth/login?redirect_uri=${window.location.origin}/auth/callback`;
export const LOGOUT_URL = `https://api.workos.com/user_management/sessions/logout?return_to=${window.location.origin}&session_id=`;

export const isLegitimateOrg = (orgId?: string) => {
  return orgId === WORKOS_LEGITIMATE_ORG_ID;
};
